import type { FileStorageAdapter } from '@/adapters/storage/types';

const resolveRecordingUri = (filePath: string): string => filePath;

const moveRecordingToDocuments = async (cacheUri: string): Promise<string> => cacheUri;

const deleteRecordingFile = async (filePath: string): Promise<void> => {
  URL.revokeObjectURL(filePath);
};

const getFileSize = async (filePath: string): Promise<number> => {
  const response = await fetch(filePath);
  if (!response.ok) {
    throw new Error(`File not found at path: ${filePath}`);
  }

  const size = (await response.blob()).size;
  if (size === 0) {
    throw new Error(`File at path ${filePath} is empty (0 bytes)`);
  }

  return size;
};

const getRecordingsDirectorySize = async (): Promise<number> => 0;

const getAvailableDiskSpaceBytes = (): number => Number.POSITIVE_INFINITY;

const fileStorage: FileStorageAdapter = {
  moveRecordingToDocuments,
  deleteRecordingFile,
  getFileSize,
  getRecordingsDirectorySize,
  getAvailableDiskSpaceBytes,
  resolveRecordingUri,
};

export { fileStorage, getFileSize };
